import { render, staticRenderFns } from "./ForceUpdate.vue?vue&type=template&id=711d747e"
import script from "./ForceUpdate.vue?vue&type=script&lang=js"
export * from "./ForceUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports